<div class="bmc-authorization-loader" *ngIf="isLoadingData">
  <bounce>{{ 'GLOBAL.LOADING_DATA' | translate }}</bounce>
</div>

<div *ngIf="!isLoadingData" class="bmc-authorization">
  <div class="bmc-authorization__header">
    <h4 class="bmc-authorization__title">{{ detailName | translate }}</h4>
    <bzg-button-primary [icon]="'icon-plus'" (click)="openAddConditionMenu()">{{'AUTHORIZATION.ADD_CONDITION' | translate}}</bzg-button-primary>
  </div>
  <div *ngIf="!dataUsers.length" class="bmc-authorization__no-conditions">
    <p class="bmc-authorization__no-conditions__message">{{'AUTHORIZATION.NO_CONDITIONS' | translate}}</p>
  </div>
  <div class="bmc-authorization__content" *ngIf="dataUsers.length">
    <div class="bmc-authorization__wrapper">
      <div id="panel-users" class="bmc-authorization__content__users">
        <h4>{{ 'AUTHORIZATION.TITLE' | translate }}</h4>
        <ul class="bmc-authorization__users">
          <li *ngFor="let item of dataUsers" class="bmc-authorization__users__item">
            <span class="bmc-authorization__users__item__text bz-space--inline-s">
              <bzg-icon class="bmc-authorization__users__item__icn bz-space bz-space--inline-s" [nameIcon]="item.itemIcon"></bzg-icon> {{item.name}}
            </span>
            <bzg-checkbox [ngModel]="selectedConditions[item.id]" (ngModelChange)="getPermissions(item.id, $event)" [checked]="selectedConditions[item.id]"></bzg-checkbox>
          </li>
        </ul>
      </div>
      <div *ngIf="selectedItemsLength > 1 && !isMultipleSelectionEnabled"class="bmc-authorization__content__permissions bmc-authorization__multiple-selection">
        <p class="bmc-authorization__center-text">
          {{ 'AUTHORIZATION.MULTIPLE_SELECTION_MESSAGE_TOP' | translate }}
        </p>
        <p class="bmc-authorization__center-text">
            {{ 'AUTHORIZATION.MULTIPLE_SELECTION_MESSAGE_BOTTOM' | translate }}
        </p>
        <bzg-button-secondary [size]="'s'" (click)="enableMultipleSelection()">{{ 'AUTHORIZATION.EDIT_PERMISSIONS' | translate }}</bzg-button-secondary>
      </div>
      <div *ngIf="selectedItemsLength <= 1 || (selectedItemsLength > 1 && isMultipleSelectionEnabled)" class="bmc-authorization__content__permissions">
        <h4>{{ 'AUTHORIZATION.PERMISSIONS' | translate }}</h4>
        <div *ngIf="selectedItemsLength === 0" class="bmc-authorization__content__no-selection">
          <p class="bmc-authorization__center-text bz-space--inset-squish-l">
            {{ 'AUTHORIZATION.NO_SELECTION_MESSAGE' | translate }}
          </p>
        </div>
        <table class="bmc-authorization__permission" *ngIf="selectedItemsLength > 0">
          <thead>
          <th></th>
          <th>{{ 'GLOBAL.ALLOW' | translate }}</th>
          <th>{{ 'GLOBAL.DENY' | translate }}</th>
          </thead>
          <tbody>
          <tr *ngFor="let permission of dataPermissions">
            <td>{{permission.typeString}}</td>
            <td class="bmc-authorization__content__permissions__option">
              <bzg-radio-button [checked]="permission.statusAllow" (change)="changeStatus(permission, 1)" ></bzg-radio-button>
            </td>
            <td class="bmc-authorization__content__permissions__option">
              <bzg-radio-button [checked]="permission.statusDeny" (change)="changeStatus(permission, 0)"></bzg-radio-button>
            </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div *ngIf="selectedItemsLength <= 1 || (selectedItemsLength > 1 && isMultipleSelectionEnabled)" class="bmc-authorization__footer">
      <bzg-button-primary (click)="save()">{{'GLOBAL.APPLY' | translate}}</bzg-button-primary>
      <bzg-button-secondary class="bz-space bz-space--inline-m" [disabled]="selectedItemsLength === 0" (click)="removeItems()">{{'GLOBAL.DELETE' | translate}}</bzg-button-secondary>
    </div>
  </div>
  <div class="bmc-authorization__add-condition" [ngClass]="{'bmc-authorization__add-condition--visible': showAddCondition}" >
    <div class="bmc-authorization__add-condition__container">
      <div class="bmc-authorization__add-condition__container--top">
        <h4>{{'AUTHORIZATION.ADD_CONDITION_TITLE' | translate }}</h4>
        <bzg-icon [nameIcon]="'icon-close'"
                  class="bmc-authorization__add-condition__close"
                  (click)="showAddCondition = false">
        </bzg-icon>
        <div class= "bmc-authorization__add-condition__options">
          <bzg-button-toggle-group (change)="showAdvanceOptions($event)" [value]="selectedFilterOption" >
            <bzg-button-toggle [value]="enumAuthorizationItemType.UserGroup">
              {{ 'AUTHORIZATION.ADD_USER_GROUP' | translate }}
            </bzg-button-toggle>
            <bzg-button-toggle [value]="enumAuthorizationItemType.Role">
              {{ 'AUTHORIZATION.ADD_USER_ROLE' | translate }}
            </bzg-button-toggle>
            <bzg-button-toggle [value]="enumAuthorizationItemType.Stakeholder">
              {{ 'AUTHORIZATION.ADD_USER_STAKEHOLDER' | translate }}
            </bzg-button-toggle>
          </bzg-button-toggle-group>
        </div>

        <div *ngIf="enumAuthorizationItemType.UserGroup === selectedFilterOption">
          <bzg-input class="filter__input" name="Filter_user_group" id="Filter_usergroup" [(ngModel)]="filterUserGroup">
            {{'AUTHORIZATION.ADD_USER_GROUP_TITLE' | translate}}
          </bzg-input>
          <ul class="bmc-authorization__add-condition__assignations">
            <li *ngFor="let assignation of advanceOptionsData | searchBy : filterUserGroup : ['content.displayName']" class="bmc-authorization__add-condition__assignations__item">                                                                                          
              <bzg-checkbox [checked]="selectedConditionsToAdd[selectedFilterOption][assignation.id] !== undefined" (change)="toggleAddCondition(assignation, $event ? $event.target?.checked : false);">
                {{assignation.content.displayName || getDisplayName(assignation)}}</bzg-checkbox>
            </li>
          </ul>
        </div>
        <div *ngIf="enumAuthorizationItemType.Role === selectedFilterOption">
          <bzg-input class="filter__input" name="Filter_Role" id="Filter_Role" [(ngModel)]="filterRole">
            {{'AUTHORIZATION.ADD_USER_ROLE_TITLE' | translate}}
          </bzg-input>
          <ul class="bmc-authorization__add-condition__assignations">
            <li *ngFor="let assignation of advanceOptionsData | searchBy : filterRole : ['content.fields.f5ee3dbd-20d5-44a0-8f5d-ae93c9f655cd','content.fields.F5EE3DBD-20D5-44A0-8F5D-AE93C9F655CD']" class="bmc-authorization__add-condition__assignations__item">                                                                                          
              <bzg-checkbox [checked]="selectedConditionsToAdd[selectedFilterOption][assignation.id] !== undefined" (change)="toggleAddCondition(assignation, $event ? $event.target?.checked : false);">
                {{assignation.content.displayName || getDisplayName(assignation)}}</bzg-checkbox>
            </li>
          </ul>
        </div>
        <div *ngIf="enumAuthorizationItemType.Stakeholder === selectedFilterOption">
          <bzg-input class="filter__input" name="Filter_StakeHolder" id="Filter_StakeHolder" [(ngModel)]="filterStakeholder">
            {{'AUTHORIZATION.ADD_USER_STAKEHOLDER_TITLE' | translate}}
          </bzg-input>
          <ul class="bmc-authorization__add-condition__assignations">
            <li *ngFor="let assignation of advanceOptionsData | searchBy : filterStakeholder : ['content.displayName']" class="bmc-authorization__add-condition__assignations__item">                                                                                          
              <bzg-checkbox [checked]="selectedConditionsToAdd[selectedFilterOption][assignation.id] !== undefined" (change)="toggleAddCondition(assignation, $event ? $event.target?.checked : false);">
                {{assignation.content.displayName || getDisplayName(assignation)}}</bzg-checkbox>
            </li>
          </ul>
        </div>
      </div>
      <div class="bmc-authorization__add-condition__footer">
        <bzg-button-primary (click)="applyConditions()">{{'GLOBAL.APPLY' | translate}}</bzg-button-primary>
        <bzg-button-secondary class="bz-space bz-space--inline-s" (click)="clearConditions()">{{'GLOBAL.CLEAR' | translate}}</bzg-button-secondary>
      </div>
    </div>
  </div>
</div>
